import * as React from 'react'

import { goToAssign, } from './shared'

const NotYetAssigned = ({ classroomId, classroomName, mobileNavigation, sequence, }) => {
  const { label, preTest, } = sequence

  function handleAssignClick() {
    goToAssign(preTest.unitTemplateId, preTest.name, preTest.activityId, classroomId)
  }

  return (
    <main className="not-yet-assigned-container">
      {mobileNavigation}
      <section className="not-yet-assigned">
        <h1>The {label} has not yet been assigned to {classroomName}</h1>
        <button className="quill-button medium contained green focus-on-light" onClick={handleAssignClick} type="button">Assign the {label} to {classroomName}</button>
      </section>
    </main>
  )
}

export default NotYetAssigned
